import { ConfigService, getConfigService } from 'src/services';

import { AccountApplicationApi } from './AccountApplicationApi';
import { AccountHolderApi } from './AccountHolderApi';
import { AccountApi } from './AccountsApi';
import { BalanceApi } from './BalanceApi';
import { InvestigationsApi } from './InvestigationsApi';
import { OfferOrdersApi } from './OfferOrdersApi';
import { OrdersApi } from './OrdersApi';
import { PrivateQuotesApi } from './PrivateQuotesApi';
import { QuoteMediaApi } from './QuoteMediaApi';
import { StatementsApi } from './StatementsApi';

export class ClientApi {
  accountApplication: AccountApplicationApi;
  account: AccountApi;
  accountHolder: AccountHolderApi;
  balance: BalanceApi;
  investigations: InvestigationsApi;
  statements: StatementsApi;
  orders: OrdersApi;
  offerOrders: OfferOrdersApi;
  privateQuotes: PrivateQuotesApi;
  quoteMedia: QuoteMediaApi;

  constructor(configService: ConfigService) {
    this.accountApplication = new AccountApplicationApi(configService);
    this.account = new AccountApi(configService);
    this.accountHolder = new AccountHolderApi(configService);
    this.balance = new BalanceApi(configService);
    this.investigations = new InvestigationsApi(configService);
    this.statements = new StatementsApi();
    this.orders = new OrdersApi();
    this.offerOrders = new OfferOrdersApi();
    this.privateQuotes = new PrivateQuotesApi();
    this.quoteMedia = new QuoteMediaApi();
  }
}

const clientApi = new ClientApi(getConfigService());

export const getClientApi = () => {
  return clientApi;
};
